<div class="summary-page" *ngIf="result">
  <h1 class="page-title">Analysis of your data file</h1>

  <p class="data-source-name" *ngIf="result.dataSourceName">
    Detected as <strong>{{ result.dataSourceName }}</strong>
  </p>

  <!-- Rejected: no fields, single reason card -->
  <div class="rejected-card" *ngIf="!result.fields; else fieldsLayout">
    <div class="rejected-card-header">
      <div class="rejected-icon">
        <mat-icon>block</mat-icon>
      </div>
      <h3 class="rejected-title">This file cannot be imported</h3>
    </div>
    <div class="rejected-card-body">
      <p class="rejected-reason" *ngIf="result.reason">{{ result.reason }}</p>
    </div>
  </div>

  <ng-template #fieldsLayout>
  <!-- Three cards grid -->
  <div class="cards-grid">
    <!-- Mandatory Fields -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Mandatory Fields</h3>
      </div>
      <div class="card-body">
        <!-- All good state -->
        <div class="all-good-banner" *ngIf="allMandatoryPresent">
          <div class="all-good-icon">
            <mat-icon>check_circle</mat-icon>
          </div>
          <div class="all-good-text">
            <span class="all-good-title">All good to go</span>
            <span class="all-good-subtitle">All mandatory fields are present</span>
          </div>
        </div>

        <!-- Missing mandatory fields list -->
        <ng-container *ngIf="!allMandatoryPresent">
          <div class="field-item field-item--error" *ngFor="let entry of mandatoryEntries">
            <span class="field-badge" [class.field-badge--present]="entry.value.exist" [class.field-badge--missing]="!entry.value.exist">
              <mat-icon>{{ entry.value.exist ? 'check' : 'close' }}</mat-icon>
            </span>
            <span class="field-name">
              {{ entry.name | titlecase }}<span *ngIf="!entry.value.exist" class="field-name--regular"> is missing</span>
            </span>
          </div>

          <!-- Action Required box -->
          <div class="action-required-box" *ngIf="missingMandatory.length > 0">
            <div class="action-required-icon">
              <mat-icon>warning</mat-icon>
            </div>
            <div class="action-required-content">
              <h4>Action Required</h4>
              <p *ngFor="let entry of missingMandatory">
                {{ entry.value.reason }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Other Missing Fields (preferred) -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Other Missing Fields</h3>
        <p class="card-subtitle">Recommended but not mandatory</p>
      </div>
      <div class="card-body">
        <div class="field-item field-item--warning" *ngFor="let entry of missingPreferred">
          <span class="field-badge field-badge--warning">
            <mat-icon>priority_high</mat-icon>
          </span>
          <div class="field-detail">
            <span class="field-name field-name--warning">{{ entry.name | titlecase }}</span>
            <span class="field-reason field-reason--warning">{{ entry.value.reason }}</span>
          </div>
        </div>
        <p class="no-fields-note" *ngIf="missingPreferred.length === 0">All recommended fields are present.</p>
      </div>
    </div>

    <!-- Fields Unable to Use (discard) -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Fields Unable to Use</h3>
      </div>
      <div class="card-body">
        <div class="field-item field-item--discard" *ngFor="let entry of discardEntries">
          <span class="field-badge field-badge--discard">
            <mat-icon>block</mat-icon>
          </span>
          <div class="field-detail">
            <span class="field-name field-name--discard">{{ entry.name }}</span>
            <span class="field-reason field-reason--discard">{{ entry.value.reason }}</span>
          </div>
        </div>
        <p class="no-fields-note" *ngIf="discardEntries.length === 0">No unsupported fields detected.</p>
      </div>
    </div>
  </div>

  <!-- Warnings section -->
  <div class="warnings-box" *ngIf="result.warnings && result.warnings.length > 0">
    <div class="warnings-icon">
      <mat-icon>warning_amber</mat-icon>
    </div>
    <div class="warnings-content">
      <h4>Warnings</h4>
      <ul>
        <li *ngFor="let w of result.warnings">{{ w }}</li>
      </ul>
    </div>
  </div>

  <!-- Recommendations section -->
  <div class="recommendations-box" *ngIf="result.recommendations && result.recommendations.length > 0">
    <div class="recommendations-icon">
      <mat-icon>lightbulb</mat-icon>
    </div>
    <div class="recommendations-content">
      <h4>Emerald's Recommendations</h4>
      <ul>
        <li *ngFor="let r of result.recommendations">{{ r }}</li>
      </ul>
    </div>
  </div>
  </ng-template>

  <!-- Action section: when result is false -->
  <div class="action-section" *ngIf="!result.result">
    <p class="action-note">Re-upload with the mandatory fields for better results</p>
    <div class="action-buttons">
      <button class="btn btn-primary" (click)="goBack()">
        <mat-icon>upload_file</mat-icon>
        Re-upload
      </button>
    </div>
  </div>

  <!-- Proceed section: when result is true -->
  <div class="proceed-section" *ngIf="result.result">
    <p class="proceed-note">How would you like to proceed?</p>
    <div class="proceed-buttons">
      <button class="btn btn-outline" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button class="btn btn-primary" (click)="proceed()">
        Proceed without reuploading
      </button>
    </div>
  </div>
</div>
